import React from 'react';
import { Box } from '@pankod/refine-mantine';

export const CommingSoon: React.FC = () => {
  return <Box style={{ padding: 50 }}>Comming Soon!</Box>;
};
